import React from 'react';
import PageTopBanner from "../components/PageTopBanner";
import { contentData } from '../data/contentData';
import '../style/pages/_quiSommesNous.scss';

const QuiSommesNous = () => {
    const selectedContent = contentData.find((content) => content.id === 5);
    return (
        <div>
            <main>
                <PageTopBanner
                    img={selectedContent.img}
                    title={selectedContent.title}
                    info={selectedContent.info}
                />

                <div className="o3academie-container">
                    <div className="container">
                        <section className="o3-description">
                            <h2>Une Entreprise Adaptée</h2>

                            <p><strong>L'Entreprise Adaptée</strong> O3 place l’humain au cœur de ses actions. Notre ambition : <strong>favoriser l’autonomie, la montée en compétences et l’épanouissement professionnel</strong> de chacun, tout en répondant aux besoins concrets des entreprises et des territoires.</p>
                        </section>

                        <section>
                            <h2>Des activités diversifiées</h2>
                            <p>Le Groupe O3 comprend plusieurs branches d’activités, dont le dénominateur commun est <strong>l’engagement pour l’inclusion</strong> et <strong>l’innovation sociale</strong> :</p>
                            <ul>
                                <li><a href="https://www.o3experts.fr/" target="_blank" rel="noopener noreferrer">O3 Experts :</a>  prestations de services administratifs externalisés dans les domaines de la paie, des RH, de la liquidation des retraites, de la comptabilité et l’archive mais également un centre d’appel.</li>
                                <li><a href="https://www.o3agri.fr " target="_blank" rel="noopener noreferrer">O3 Agri :</a> acteur de l’agriculture durable et locale à travers ses ruchers. O3 Agri fabrique son miel et conçoit à travers de matière premières locales des confitures, du caramel, des huiles végétales, …</li>
                                <li><a href="https://www.lesateliersdo3.fr/ " target="_blank" rel="noopener noreferrer">Les Ateliers d'O3 :</a>  ateliers de confection textile haut de gamme, permettant de répondre aux exigences les plus précises de nos clients, nous produisons en petites et moyennes séries.  Les Ateliers développent également une gamme personnalisée de vêtements pour les entreprises.</li>
                                <li><a href="https://www.o3experts.fr/nos-prestations/detail-prestation/services-numeriques-ingenierie-informatique-et-cybersecurite" target="_blank" rel="noopener noreferrer">O3 IT</a> : prestation de tests logiciels, accessibilité numérique, développement de solutions digitales et cybersécurité.</li>
                            </ul>

                            <p className='conclusion'>Chacune de nos filiales incarne l’esprit d’O3 : <strong>entreprendre autrement</strong>, avec exigence, créativité et solidarité. Ensemble, nous construisons une économie plus inclusive et plus résiliente.</p>
                        </section>

                    </div>
                </div>
            </main>
        </div>
    );
};

export default QuiSommesNous;